export const AppRoutes = {
  ANALYTICS: '/analytics',
  FINISH_SETUP: '/finish-setup',
  GONG_CALLBACK: '/gong-callback',
  SALESLOFT_CALLBACK: '/salesloft-callback',
  KNOWLEDGE_HUB: '/knowledge-hub',
  HOME: '/',
  NOT_FOUND: '*', // Matches any path that hasn't matched above.
  SETTINGS: '/settings',
  SIMULATIONS: '/simulations',
  PROMPT_TEMPLATES: '/prompt-templates',
  PROMPT_TEMPLATES_CREATE: '/prompt-templates/create',
  PROSPECT: '/prospect',
  REVIEW: '/review',
  SCORING_AND_COACHING: '/scoring-and-coaching',
  SCORECARDS: '/scoring-and-coaching/scorecards',
  COACHING_RUBRICS: '/scoring-and-coaching/coaching-rubrics',
};
